import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBaseImage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_111392_2343)",
			children: /* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_111392_2343)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M7.80832 13.25C7.74645 13.25 7.68261 13.2354 7.61877 13.2063L1.82223 10.3134C1.67743 10.2403 1.58693 10.09 1.58693 9.92182C1.58693 9.75361 1.67973 9.60163 1.82354 9.53022L3.9376 8.47488L1.8219 7.42258C1.67611 7.34913 1.58561 7.19784 1.58693 7.02894C1.58693 6.86106 1.67973 6.7074 1.82354 6.63598L3.93727 5.58335L1.82223 4.52665C1.67743 4.45354 1.58693 4.30326 1.58693 4.13505C1.58693 3.96683 1.67743 3.81486 1.82288 3.74107L7.62173 0.849204C7.68031 0.820435 7.74283 0.805542 7.80733 0.805542C7.87184 0.805542 7.93337 0.820096 7.99162 0.849204L13.7931 3.74175C13.9379 3.81486 14.032 3.96954 14.032 4.13505C14.032 4.30056 13.9402 4.45253 13.7921 4.52699L11.6774 5.58335L13.7931 6.63564C13.9399 6.70977 14.0317 6.86005 14.0317 7.02725C14.0317 7.19445 13.9379 7.34846 13.7931 7.42055L11.6813 8.47318L13.7924 9.52785C13.9372 9.60096 14.0314 9.75564 14.0314 9.92148C14.0314 10.0873 13.9395 10.239 13.7915 10.3134L7.99097 13.2073C7.93535 13.2341 7.86953 13.25 7.80832 13.25ZM2.98028 7.02725L7.80832 9.4368L12.6364 7.02691L10.7049 6.06837L7.99129 7.42089C7.937 7.4483 7.87217 7.4632 7.80832 7.4632C7.7402 7.4632 7.67998 7.44932 7.62864 7.4219L4.91137 6.06668L2.98028 7.02725ZM2.98028 4.13505L7.80799 6.54223L12.6357 4.13505L7.80799 1.72787L2.98028 4.13505Z",
					fill: "currentColor"
				})
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_111392_2343",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(0.809082 0.027771)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_111392_2343",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12.4444,
				height: 12.4444,
				fill: "white",
				transform: "translate(1.58691 0.805542)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgBaseImage);
export { ForwardRef as ReactComponent };
